import { observer } from "mobx-react-lite";
import { useTranslation } from "../i18n/useTranslation.js";
import { LANDING_LANGUAGES, type SupportedLanguage } from "../i18n/i18nStore.js";

const LanguageSwitch = observer(() => {
  const { language, setLanguage, t } = useTranslation();
  return (
    <label className="landing-language">
      <span className="sr-only">{t("landing.nav.language")}</span>
      <select value={language} aria-label={t("landing.nav.language")}
        onChange={(event) => setLanguage(event.target.value as SupportedLanguage)}>
        {LANDING_LANGUAGES.map((entry) => (
          <option key={entry.code} value={entry.code}>{entry.nativeName}</option>
        ))}
      </select>
    </label>
  );
});

export default LanguageSwitch;
